import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] bg-[#FAF9F6] flex items-center justify-center pt-36 sm:pt-44 pb-20 px-4">
      <SEO
        title="404 - Siden blev ikke fundet | ET Danmark ApS"
        description="Den efterspurgte side kunne ikke findes på etdanmark.com."
        noindex={true}
      />
      <div className="max-w-lg w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-3xl bg-emerald-100 text-[#165B4C] flex items-center justify-center text-3xl mx-auto shadow-sm">
          <i className="fa-solid fa-compass" aria-hidden="true"></i>
        </div>

        <span className="text-xs font-bold uppercase tracking-widest text-[#165B4C] bg-emerald-100/60 px-3 py-1 rounded-full">
          Fejl 404
        </span>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
          Siden blev ikke fundet
        </h1>

        <p className="text-stone-600 text-sm leading-relaxed">
          Vi beklager, men den side du leder efter, findes ikke eller er blevet flyttet. Brug venligst nedenstående links til at finde det, du søger:
        </p>

        <div className="grid grid-cols-2 gap-3 pt-2 text-xs font-semibold">
          <Link
            to="/"
            className="p-3 rounded-xl bg-white border border-stone-200 hover:border-emerald-300 text-stone-800 transition-colors flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-house text-[#165B4C]" aria-hidden="true"></i>
            <span>Forside</span>
          </Link>
          <Link
            to="/prisberegner"
            className="p-3 rounded-xl bg-white border border-stone-200 hover:border-emerald-300 text-stone-800 transition-colors flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-calculator text-[#165B4C]" aria-hidden="true"></i>
            <span>Prisberegner</span>
          </Link>
          <Link
            to="/priser"
            className="p-3 rounded-xl bg-white border border-stone-200 hover:border-emerald-300 text-stone-800 transition-colors flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-tag text-[#165B4C]" aria-hidden="true"></i>
            <span>Priser</span>
          </Link>
          <Link
            to="/kontakt"
            className="p-3 rounded-xl bg-white border border-stone-200 hover:border-emerald-300 text-stone-800 transition-colors flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-envelope text-[#165B4C]" aria-hidden="true"></i>
            <span>Kontakt os</span>
          </Link>
        </div>

        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#165B4C] hover:bg-[#11463A] text-white font-bold text-sm shadow transition-colors"
          >
            <i className="fa-solid fa-arrow-left text-xs" aria-hidden="true"></i>
            <span>Gå til forsiden</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
